import { AdminSubheader } from "features/AdminSubheader";
import { isGranted } from "pages/productManagement/functions";
import { Permission } from "pages/productManagement/types";

export function ProductManagementSubscriptionsSubheader() {
	const canReadSubscriptions = isGranted("subscriptions", Permission.READ);
	const canReadTeamGroups = isGranted("team_groups", Permission.READ);

	const items: { label: string; link: string }[] = [];

	if (canReadSubscriptions) {
		items.push({
			label: "Subscriptions",
			link: "/subscription",
		});
	}

	if (canReadTeamGroups) {
		items.push({
			label: "Team Groups",
			link: "/team-group",
		});
	}

	if (items.length === 0) {
		return null;
	}

	return <AdminSubheader items={items} />;
}
